import React from 'react'
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow_back.svg'
import { ReactComponent as UniversityIcon } from 'assets/icons/university.svg'
import { ReactComponent as CapIcon } from 'assets/icons/cap.svg'
import { ReactComponent as LocationIcon } from 'assets/icons/location.svg'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'
import { ReactComponent as DonutLargeIcon } from 'assets/icons/donut_large.svg'
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg'
import { ReactComponent as SmartToyIcon } from 'assets/icons/smart_toy.svg'
import { ReactComponent as SendIcon } from 'assets/icons/send.svg'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import { ReactComponent as DockArticleIcon } from 'assets/icons/dock_article.svg'
import { ReactComponent as AppsIcon } from 'assets/icons/apps.svg'
import { ReactComponent as EventIcon } from 'assets/icons/event.svg'
import { ReactComponent as VerifiedIcon } from 'assets/icons/verified.svg'
import { ReactComponent as ArrowShortRightIcon } from 'assets/icons/arrow_short_right.svg'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'
import { ReactComponent as PenIcon } from 'assets/icons/pen.svg'
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg'
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg'
import { ReactComponent as LeaderboardIcon } from 'assets/icons/leaderboard.svg'
import { ReactComponent as ArrowSquareIcon } from 'assets/icons/arrow_square.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import { ReactComponent as DockPanIcon } from 'assets/icons/dock_pen.svg'
import s from './AppDetailIcon.module.scss'

const ICONS = {
	arrow_back: ArrowBackIcon,
	account_balance: UniversityIcon,
	school: CapIcon,
	place: LocationIcon,
	schedule: ClockIcon,
	donut_large: DonutLargeIcon,
	lock: LockIcon,
	smart_toy: SmartToyIcon,
	send: SendIcon,
	description: DockIcon,
	article: DockArticleIcon,
	apps: AppsIcon,
	event: EventIcon,
	verified: VerifiedIcon,
	chevron_right: ArrowShortRightIcon,
	chevron_left: ArrowShortRightIcon,
	add: PlusIcon,
	edit: PenIcon,
	chat_bubble: MessageIcon,
	chat_bubble_outline: MessageIcon,
	info: InfoIcon,
	leaderboard: LeaderboardIcon,
	open_in_new: ArrowSquareIcon,
	check: CheckIcon,
	arrow_forward: ArrowBackIcon,
	dock_pen: DockPanIcon,
}

export const AppDetailIcon = ({ name, size = 18, className = '' }) => {
	if (name === 'remove') {
		return (
			<span
				className={`${s.remove} ${className}`.trim()}
				style={{ width: size, height: Math.max(2, Math.round(size * 0.1)) }}
				aria-hidden="true"
			/>
		)
	}

	const Icon = ICONS[name]
	if (!Icon) return null

	const transform =
		name === 'chevron_left'
			? 'rotate(180deg)'
			: name === 'arrow_forward'
				? 'rotate(180deg)'
				: undefined

	return (
		<Icon
			className={className}
			width={size}
			height={size}
			aria-hidden="true"
			style={transform ? { transform } : undefined}
		/>
	)
}
